export const clearCookies = () => {
	document.cookie.split(';').forEach((cookie) => {
		const [name] = cookie.trim().split('=');
		if (name && name.includes('msal')) {
			document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
		}
	});
};
